"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Validators = /** @class */ (function () {
    function Validators() {
    }
    /** coordinates type could by number[] or number[][] */
    Validators.validateCoordinateNumbers = function (coordinates, validLength) {
        if (coordinates.length < validLength) {
            throw new Error("Coordinates must have at least " + validLength + " numbers.");
        }
    };
    return Validators;
}());
exports.default = Validators;
